import { createAction, props } from '@ngrx/store';
import { Domain } from '../models/domain.model';

export const loadDomains = createAction('[Domains] Load Domains');

export const loadDomainsSuccess = createAction(
  '[Domains] Load Domains Success',
  props<{ domains: Domain[] }>()
);

export const loadDomainsFailure = createAction(
  '[Domains] Load Domains Failure',
  props<{ error: string }>()
);

export const setCurrentDomainId = createAction(
  '[Domains] Set Current Domain Id',
  props<{ domainId: string | null }>()
);

